<script>
  export default {
    created() {},
    beforeDestroy() {},
    methods: {}
  };
</script>
